const getters = {
  isShowLoginDialog: state => state.login.isShowLoginDialog,
  isShowRegisterDialog: state => state.login.isShowRegisterDialog,
  bg: state => state.styleConfig.style,
  isBlockPopup: state => state.login.isBlockPopup,
  isMobile: state => state.user.isMobile
};
export default getters;
